module.exports = __webpack_public_path__ + "img/waves-8.be7ce821.jpg";